export default __webpack_public_path__ + "static/media/pic2.77a4c646.jpg";